var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF5C7B",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9143 16.3123C20.3205 15.8498 19.4768 15.906 18.9393 16.4373L16.4393 18.9373C15.908 19.4685 15.8518 20.3123 16.308 20.9123L21.308 27.4123C21.5893 27.781 22.033 27.9998 22.4955 27.9998H25.8768L32.6893 34.8123C31.7705 36.6248 32.0643 38.8998 33.583 40.4123L40.583 47.4123C41.3643 48.1935 42.633 48.1935 43.4143 47.4123L47.4143 43.4123C48.1955 42.631 48.1955 41.3623 47.4143 40.581L40.4143 33.581C38.9018 32.0685 36.6268 31.7685 34.8143 32.6873L28.0018 25.8748V22.4935C28.0018 22.0248 27.783 21.5873 27.4143 21.306L20.9143 16.3123ZM17.2455 40.756C16.4518 41.5498 16.0018 42.631 16.0018 43.756C16.0018 46.0998 17.9018 47.9998 20.2455 47.9998C21.3705 47.9998 22.4518 47.5498 23.2455 46.756L30.608 39.3935C30.1205 38.0873 30.0455 36.6685 30.383 35.3248L26.5268 31.4685L17.2455 40.756ZM48.0018 24.9998C48.0018 24.3435 47.933 23.706 47.8018 23.0935C47.6518 22.3935 46.7955 22.2123 46.2893 22.7185L42.2955 26.7123C42.108 26.8998 41.8518 27.006 41.5893 27.006L38.0018 26.9998C37.4518 26.9998 37.0018 26.5498 37.0018 25.9998V22.4123C37.0018 22.1498 37.108 21.8935 37.2955 21.706L41.2893 17.7123C41.7955 17.206 41.6143 16.3498 40.9143 16.1998C40.2955 16.0685 39.658 15.9998 39.0018 15.9998C34.033 15.9998 30.0018 20.031 30.0018 24.9998V25.0498L35.333 30.381C37.583 29.8123 40.0705 30.4123 41.833 32.1748L42.8143 33.156C45.8768 31.7185 48.0018 28.606 48.0018 24.9998ZM19.5018 42.9998C19.5018 42.6019 19.6598 42.2204 19.9411 41.9391C20.2224 41.6578 20.6039 41.4998 21.0018 41.4998C21.3996 41.4998 21.7811 41.6578 22.0624 41.9391C22.3437 42.2204 22.5018 42.6019 22.5018 42.9998C22.5018 43.3976 22.3437 43.7791 22.0624 44.0604C21.7811 44.3417 21.3996 44.4998 21.0018 44.4998C20.6039 44.4998 20.2224 44.3417 19.9411 44.0604C19.6598 43.7791 19.5018 43.3976 19.5018 42.9998Z",
    fill: "#FF5C7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.186b93bafd2d5b77d25ceda5bd68ccf8.svg";
export { ForwardRef as ReactComponent };